import ReviewFre from '@reviews/review-fre.mdx';
import Review22120 from '@reviews/review-22120.mdx';
import ReviewSnowpack from '@reviews/review-snowpack.mdx';
import React from 'react';
export default {
  ReviewFre,
  Review22120,
  ReviewSnowpack,
  React
};